import 'vuetify/styles'
import './app/assets/styles/app.scss'
import '@vuepic/vue-datepicker/dist/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './app/App.vue'

import router from './app/routes'
import Translate from '@/shared/lib/i18n'
import VuetifyConfig from '@/shared/lib/vuetify'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { phone, installDisableAutocomplete } from '@/shared/lib'
import { VueDatePicker } from '@vuepic/vue-datepicker'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Translate)
app.use(VuetifyConfig)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  },
})

app.component('VueDatePicker', VueDatePicker)

app.directive('phone', phone)

app.mount('#app')

installDisableAutocomplete()

/**
 * Авто-перезагрузка при смене версии сборки: после деплоя старые
 * хешированные чанки удаляются с сервера, и ленивый import() маршрута
 * падает с preloadError. Без перезагрузки страницы паспорта не открываются.
 */
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})
